var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.isLoading)?_c('VehicleList',{staticClass:"related-vehicles-list",attrs:{"vehicles":_vm.relatedVehicles,"list-name":"pdp_similar"}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }